import { render, staticRenderFns } from "./courseIndex.vue?vue&type=template&id=cb805a40&scoped=true"
import script from "./courseIndex.vue?vue&type=script&lang=js"
export * from "./courseIndex.vue?vue&type=script&lang=js"
import style0 from "./courseIndex.vue?vue&type=style&index=0&id=cb805a40&prod&lang=scss&scoped=true"
import style1 from "./courseIndex.vue?vue&type=style&index=1&id=cb805a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb805a40",
  null
  
)

export default component.exports